<div class="container">
  <div class="header" *ngIf="!isUserLoggedIn">
    <img src="assets/images/logo-upperleft.png" [routerLink]="['/']" class="logo-image link" alt="Logo" />
    <div class="logo-title link" [routerLink]="['/']">
      {{ 'app.service_portal' | translate }}
    </div>
  </div>
  <div class="error-content">
    <ng-content></ng-content>
  </div>
  <div class="related-links-section">
    <div class="dashboard-links" [routerLink]="['/panel']">Home</div>
    <div class="dashboard-links" (click)="openImprint()">Impressum</div>
  </div>
</div>
